const comments = [
  {
    name: '深夜追剧小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20illustration%20avatar%20of%20a%20young%20person%20with%20glasses%20in%20warm%20orange%20and%20terracotta%20tones%2C%20simple%20geometric%20style%2C%20profile%20portrait%20with%20soft%20shapes&width=100&height=100&seq=avatar-comment-01&orientation=squarish',
    time: '2小时前',
    rating: 5,
    text: '作为一个资深夜猫子，终于找到一个凌晨更新还能秒播的平台了！《暗夜追踪》追到凌晨三点一点都不卡，强烈推荐给所有熬夜党。',
    tag: '老用户',
  },
  {
    name: '月光下的爆米花',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20illustration%20avatar%20of%20a%20person%20with%20wavy%20hair%20in%20warm%20coral%20and%20amber%20tones%2C%20simple%20geometric%20style%2C%20profile%20portrait%20with%20clean%20lines&width=100&height=100&seq=avatar-comment-02&orientation=squarish',
    time: '5小时前',
    rating: 5,
    text: '片库真的很全！之前到处找的老电影这里居然都有，画质也很清晰。午夜看老片的氛围感拉满，太适合我了。',
    tag: '影视达人',
  },
  {
    name: '不眠夜旅人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20illustration%20avatar%20of%20a%20person%20with%20beanie%20hat%20in%20warm%20terracotta%20and%20gold%20tones%2C%20simple%20geometric%20style%2C%20profile%20portrait%20with%20cozy%20vibe&width=100&height=100&seq=avatar-comment-03&orientation=squarish',
    time: '8小时前',
    rating: 4,
    text: '手机端体验很不错，躺床上刷剧很方便。希望后续能增加更多纪录片类型，最近对暗网题材特别感兴趣。',
    tag: '新用户',
  },
  {
    name: '半夜间谍猫',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20flat%20illustration%20avatar%20of%20a%20person%20with%20cat%20ears%20headband%20in%20warm%20amber%20and%20coral%20tones%2C%20simple%20geometric%20style%2C%20playful%20profile%20portrait&width=100&height=100&seq=avatar-comment-04&orientation=squarish',
    time: '12小时前',
    rating: 5,
    text: '凌晨两点准时蹲更新已经成了我的日常！《午夜食堂》看得我又饿又感动，每集都在深夜温暖治愈。感谢夜猫电影院的存在！',
    tag: '忠实用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            夜猫子说
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-md mx-auto">
            来自深夜追剧同好们的真实观影感受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-secondary-100">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                    <span className="px-2 py-0.5 rounded-full bg-accent-50 text-accent-600 text-[10px] font-medium">
                      {comment.tag}
                    </span>
                  </div>
                  <div className="flex items-center gap-1 mt-1">
                    {Array.from({ length: comment.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-primary-400 text-xs"></i>
                    ))}
                    {Array.from({ length: 5 - comment.rating }).map((_, j) => (
                      <i key={`e${j}`} className="ri-star-line text-foreground-300 text-xs"></i>
                    ))}
                    <span className="text-xs text-foreground-400 ml-2">{comment.time}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}